import { useIntl } from "react-intl"
import { useFormat } from "@/lib/format"
import type { Allowance, SourceKind } from "@/types/generations"

export const SOURCE_KIND_LABELS: Record<SourceKind, { id: string }> = {
  text: { id: "sources.kind_text" },
  url: { id: "sources.kind_url" },
  file: { id: "sources.kind_file" },
}

/**
 * A short notice about the AI allowance (daily or monthly), or null when there's plenty left.
 * `kind` picks the noun: "generation" (AI generations) or "assistant" (assistant messages).
 */
export function useAllowanceNotice() {
  const intl = useIntl()
  const { date } = useFormat()
  return (allowance: Allowance, kind: "generation" | "assistant" = "generation") => {
    if (allowance.unlimited) return null
    const noun =
      kind === "generation" ? intl.formatMessage({ id: "allowance.noun_generation" }) : intl.formatMessage({ id: "allowance.noun_assistant" })
    const monthly = allowance.period === "month"
    if (allowance.remaining === 0) {
      return monthly
        ? intl.formatMessage(
            { id: "allowance.used_up_month" },
            { limit: allowance.limit, noun, date: date(allowance.resets_on, { month: "short", day: "numeric" }) },
          )
        : intl.formatMessage({ id: "allowance.used_up_day" }, { limit: allowance.limit, noun })
    }
    if (allowance.remaining <= allowance.warn_at) {
      const values = { remaining: allowance.remaining, limit: allowance.limit, noun }
      return monthly ? intl.formatMessage({ id: "allowance.low_month" }, values) : intl.formatMessage({ id: "allowance.low_day" }, values)
    }
    return null
  }
}
